import { DummyStore } from 'src/stores';

import { SyncType } from '../types';

export const syncStore = new DummyStore<SyncType>();
export const syncDistancesStore = new DummyStore<SelectOption[]>([]);
export const raceDistancesStore = new DummyStore<SelectOption[]>([]);
export const distancesTypeStore = new DummyStore<{ id: number; type: string }[]>([]);
